// extracted by mini-css-extract-plugin
export default {"questions":"_2822dcba","questionsSoldRedesign":"_8cf5ae2b","buttons":"_df90c122","requestPrice":"_c0948b7b","contactSellerButton":"_db100030"};